import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import type { ProviderOverviewProps } from "@/ui/components/onboarding/ProviderOverview";
import ProviderOverview from "@/ui/components/onboarding/ProviderOverview";

const StoryMeta: Meta<ProviderOverviewProps> = {
  title: "Components/Onboarding/Provider Overview",
  component: ProviderOverview,
  argTypes: {
    email: { control: "text" },
    fullName: { control: "text" },
    isReferring: { control: "boolean" },
    phoneNumber: { control: "text" },
    practiceLocation: { control: "text" },
    specialty: { control: "text" },
  },
  args: {
    email: faker.internet.email(),
    fullName: faker.person.fullName(),
    isReferring: faker.datatype.boolean(),
    phoneNumber: faker.phone.number(),
    practiceLocation: "UCSF Adolescent & Young Adult Clinic",
    specialty: "Adolescent Medicine",
  },
};

type Story = StoryObj<ProviderOverviewProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
